module.exports = __webpack_public_path__ + "static/media/hangman-tb.a0a665b6.png";